/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OutputWebAuthnCredentialInfo } from './OutputWebAuthnCredentialInfo';
import {
    OutputWebAuthnCredentialInfoFromJSON,
    OutputWebAuthnCredentialInfoFromJSONTyped,
    OutputWebAuthnCredentialInfoToJSON,
} from './OutputWebAuthnCredentialInfo';

/**
 * 
 * @export
 * @interface OutputTwoFactorStatusResponse
 */
export interface OutputTwoFactorStatusResponse {
    /**
     * 
     * @type {boolean}
     * @memberof OutputTwoFactorStatusResponse
     */
    enabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OutputTwoFactorStatusResponse
     */
    hasTotp?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OutputTwoFactorStatusResponse
     */
    hasWebAuthn?: boolean;
    /**
     * 
     * @type {Array<OutputWebAuthnCredentialInfo>}
     * @memberof OutputTwoFactorStatusResponse
     */
    webauthnCredentials?: Array<OutputWebAuthnCredentialInfo>;
}

/**
 * Check if a given object implements the OutputTwoFactorStatusResponse interface.
 */
export function instanceOfOutputTwoFactorStatusResponse(value: object): boolean {
    return true;
}

export function OutputTwoFactorStatusResponseFromJSON(json: any): OutputTwoFactorStatusResponse {
    return OutputTwoFactorStatusResponseFromJSONTyped(json, false);
}

export function OutputTwoFactorStatusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputTwoFactorStatusResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'hasTotp': json['hasTotp'] == null ? undefined : json['hasTotp'],
        'hasWebAuthn': json['hasWebAuthn'] == null ? undefined : json['hasWebAuthn'],
        'webauthnCredentials': json['webauthnCredentials'] == null ? undefined : ((json['webauthnCredentials'] as Array<any>).map(OutputWebAuthnCredentialInfoFromJSON)),
    };
}

export function OutputTwoFactorStatusResponseToJSON(value?: OutputTwoFactorStatusResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'enabled': value['enabled'],
        'hasTotp': value['hasTotp'],
        'hasWebAuthn': value['hasWebAuthn'],
        'webauthnCredentials': value['webauthnCredentials'] == null ? undefined : ((value['webauthnCredentials'] as Array<any>).map(OutputWebAuthnCredentialInfoToJSON)),
    };
}

